import { ReactNode } from "react";

import ChevronDown from "@/assets/icons/chevron-down.svg";
import { cx } from "@/utils";
import Typography from "@components/Typography";
import * as RadixAccordion from "@radix-ui/react-accordion";
export { Root as AccordionGroup } from "@radix-ui/react-accordion";

import styles from "./Accordion.module.css";

type AccordionProps = {
  children?: ReactNode;
  indicator?: ReactNode;
  title: string;
  preview?: ReactNode;
  className?: string;
  disabled?: boolean;
  value: string;
} & RadixAccordion.AccordionTriggerProps;

export const Accordion: React.FunctionComponent<AccordionProps> = ({
  children,
  title,
  indicator = null,
  preview,
  disabled,
  className,
  value,
  ...props
}) => {
  return (
    <RadixAccordion.Item value={value} className={cx(styles.root, className)}>
      <RadixAccordion.Header asChild>
        <RadixAccordion.Trigger
          disabled={disabled}
          className={styles.header}
          {...props} // passing props here mainly for data-testid to be on a clickable element
        >
          <div className={styles.cut}>
            <Typography className={styles.cancelMargins} variant="subtitle-1">
              {title}
            </Typography>
            <Typography
              className={cx(styles.preview, styles.cancelMargins)}
              variant="body-1"
            >
              {preview}
            </Typography>
          </div>
          <div>
            {indicator}
            <ChevronDown height={16} strokeWidth={2} className={styles.icon} />
          </div>
        </RadixAccordion.Trigger>
      </RadixAccordion.Header>

      <RadixAccordion.Content asChild>
        <main className={cx(styles.content, styles.animate)}>{children}</main>
      </RadixAccordion.Content>
    </RadixAccordion.Item>
  );
};
